import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DatasourceModule } from './datasource/datasource.module';
import {CommonCodeModule } from './common-code/common-code.module';
import { DatePipe } from '@angular/common';
import { 
          DxDataGridModule,
          DxSelectBoxModule,
          DxCheckBoxModule,
          DxButtonGroupModule,
          DxHtmlEditorModule
        } from 'devextreme-angular';
import { LoginComponent } from './login/login.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,    
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxButtonGroupModule,
    DxHtmlEditorModule,
    ReactiveFormsModule,
    DatasourceModule,
    CommonCodeModule
    
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
